import React from "react";
import ExifOrientationImg from "react-exif-orientation-img";
import { Formik, Form, Field } from "formik";

import IconButton from "@material-ui/core/IconButton";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import { makeStyles } from "@material-ui/core/styles";

import DeleteIcon from "@material-ui/icons/Delete";

import ProgressBar from "../loader/ProgressBar";
import TextField from "../formik/TextField";
import { IMG_BG_COLOR, REGEX_URL } from "../../config";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    margin: "auto",
    backgroundColor: "#212121",
    marginTop: theme.spacing(1),
    maxWidth: 700,
  },
  img: {
    width: 150,
    height: 150,
    margin: "auto",
    objectFit: "contain",
    backgroundColor: IMG_BG_COLOR,
  },
  form: {
    display: "flex",
    flexDirection: "column",
  },
  input: { padding: 0, margin: 0 },
  inputProps: {
    fontSize: "12px",
  },
  progress: {
    marginTop: "20px",
    paddingRight: "15px",
    height: "10px",
  },
}));

export default function UploadPreviewGrid({
  media,
  removeMedia,
  updateMediaData,
  setErrors,
  isSubmitting,
  uploadProgress,
}) {
  const classes = useStyles();

  function handleRemoveClick() {
    removeMedia(media.key, media.url);
  }

  return (
    <Paper className={classes.paper}>
      <Grid container spacing={2}>
        <Grid item>
          <ExifOrientationImg
            src={media.url}
            alt={media.name}
            className={classes.img}
          />
          <Grid item style={{ display: "flex", justifyContent: "center" }}>
            <IconButton
              aria-label="delete"
              className={classes.margin}
              onClick={handleRemoveClick}
              disabled={isSubmitting}
            >
              <DeleteIcon fontSize="small" />
            </IconButton>
          </Grid>
        </Grid>
        <Grid item xs={12} sm container>
          <Grid item xs container direction="column" spacing={2}>
            <Grid item xs>
              {media.name}
              <Formik
                initialValues={{
                  caption: "",
                  description: "",
                  attributionName: "",
                  attributionUrl: "",
                }}
                validate={(values) => {
                  let errors = {};

                  if (values.attributionUrl.trim().length > 0) {
                    if (!REGEX_URL.test(values.attributionUrl)) {
                      errors.attributionUrl = "Invalid URL";
                      setErrors(media.key, 1);
                    } else {
                      setErrors(media.key, 0);
                    }
                  } else {
                    setErrors(media.key, 0);
                  }

                  updateMediaData(media.key, values);

                  return errors;
                }}
              >
                {(props) => {
                  const { errors } = props;

                  return (
                    <Form className={classes.form}>
                      <Field
                        component={TextField}
                        name="caption"
                        margin="normal"
                        label="Short Description"
                        className={classes.input}
                        InputLabelProps={{ className: classes.inputProps }}
                        inputProps={{ className: classes.inputProps }}
                        disabled={isSubmitting}
                      />
                      <Field
                        component={TextField}
                        name="description"
                        margin="normal"
                        label="Description"
                        multiline
                        maxRows={100}
                        className={classes.input}
                        InputLabelProps={{ className: classes.inputProps }}
                        inputProps={{ className: classes.inputProps }}
                        disabled={isSubmitting}
                      />
                      <Field
                        component={TextField}
                        name="attributionName"
                        margin="normal"
                        label="Attribution Name"
                        className={classes.input}
                        InputLabelProps={{ className: classes.inputProps }}
                        inputProps={{ className: classes.inputProps }}
                        disabled={isSubmitting}
                      />
                      <Field
                        component={TextField}
                        name="attributionUrl"
                        margin="normal"
                        label="Attribution URL"
                        className={classes.input}
                        InputLabelProps={{ className: classes.inputProps }}
                        inputProps={{ className: classes.inputProps }}
                        helperText={
                          errors.attributionUrl && errors.attributionUrl
                        }
                        error={!!errors.attributionUrl}
                        disabled={isSubmitting}
                      />
                    </Form>
                  );
                }}
              </Formik>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid container className={classes.progress}>
        <ProgressBar visible={isSubmitting} completed={uploadProgress} />
      </Grid>
    </Paper>
  );
}
